<mat-dialog-content>
  <h2>
    <strong>{{ 'Warehouse List' | translate }}</strong>
  </h2>
  <form>
    @if (listWare.length > 0) {
      <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>
              <mat-label>Item</mat-label>
            </th>
            <th>
              <mat-label>ID</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Warehouse' | translate }}</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Options' | translate }}</mat-label>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (warehouse of listWare; track warehouse; let i = $index) {
            <tr>
              <td data-label="Item">
                {{ i }}
              </td>
              <td data-label="ID">
                {{ warehouse.id_almacen }}
              </td>
              <td data-label="Warehouse">
                {{ warehouse.nombre }}
              </td>
              <td data-label="Options">
                <button
                  (click)="remove(warehouse.id_almacen, i)"
                  mat-raised-button
                >
                  x
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    <br />
    @if (listWare.length <= 0) {
      <div class="alert alert-danger">
        {{ 'NO RECORDS FOUND' | translate }}
      </div>
    }
    <br />
    <form [formGroup]="registerForm">
      <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>
              <mat-label>{{ 'Add Warehouse' | translate }}</mat-label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Add Warehouse">
              <input
                style="width: 400px"
                class="form-control"
                type="text"
                formControlName="warehouse"
              />
              @if (textValid('warehouse')) {
                <span class="form-text text-danger">{{
                  'Warehouse invalid' | translate
                }}</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <button
        mat-raised-button
        (click)="update()"
        style="margin-left: 20px; margin-bottom: 20px"
      >
        {{ 'Add' | translate }}
      </button>
      <button
        mat-raised-button
        mat-dialog-close
        style="margin-left: 20px; margin-bottom: 20px"
      >
        {{ 'Close' | translate }}
      </button>
    </form>
  </form>
</mat-dialog-content>
